import { ContentType } from '@/enums/http'
import request from '@/utils/request'
import {
  AccountInfo,
  changePasswordParams,
  LoginByOuterSys,
  LoginParams,
  LoginResponse,
  ParamsCheckAndIncreaseUserPageVisitNum,
  ResCheckAndIncreaseUserPageVisitNum
} from './model.d'

export function login(data: LoginParams) {
  return request.post<LoginResponse>({
    url: '/user/login',
    data,
    headers: {
      'Content-Type': ContentType.FORM_DATA
    }
  })
}
/**
 * 通过外用户id登录
 * @param data 登录信息
 * @backend 吴晓军
 */
export function loginByOuterSys(data: LoginByOuterSys) {
  return request.post<LoginResponse>(
    {
      url: '/user/loginByOuterSys',
      data
    },
    { errorMessageMode: 'none' }
  )
}

export function logout(params = {}) {
  return request.post({
    url: '/user/logout',
    params
  })
}

export function changePassword(data: changePasswordParams) {
  return request.post(
    {
      url: '/user/changePassword',
      data
    },
    {
      defaultSuccessMsg: true
    }
  )
}

/** 增加/查询/清除特定页面的访问次数 */
export function checkAndIncreaseUserPageVisitNum(data: ParamsCheckAndIncreaseUserPageVisitNum) {
  return request.post<ResCheckAndIncreaseUserPageVisitNum[]>({
    url: '/user/checkAndIncreaseUserPageVisitNum',
    data
  })
}

/** 查询用户的账号列表 */
export function getUserAccountList() {
  return request.post<AccountInfo[]>({
    url: '/user/getBeyondSupplier'
  })
}
